import { IStoreState, ThunkDispatch } from "../../../modules";
import React, { ChangeEvent, Fragment } from "react";
import { Switch, Theme, WithStyles, createStyles, withStyles } from "@material-ui/core";
import { getEnrolledOobBio, updateOobBio } from "../../../modules/authmethods";

import GenericEnroll from "./GenericEnroll";
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const styles = (theme: Theme) => createStyles({

})

type OobSmsEnrollState = {
  enrolled: boolean
  loading: boolean
  error: string
}

class OobBioEnroll extends React.Component<Props, OobSmsEnrollState> {
  static propTypes = {
    expanded: PropTypes.bool.isRequired,
    setExpanded: PropTypes.func.isRequired
  }

  state = {
    enrolled: false,
    loading: true,
    error: "",
  }

  componentDidMount = () => {
    this.reloadEnrolment()
  }

  reloadEnrolment = () => {
    this.props.getEnrolledOobBio().then((_: any) => {
      let enrolled = this.props.authmethods.oobBio.enrolled

      this.setState({
        enrolled,
        loading: false,
        error: "",
      })
    })
  }

  handleEnrolledChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({
      loading: true
    })
    this.props.updateOobBio(e.target.checked).finally(() => {
      this.reloadEnrolment()
    })

  }

  renderForm = () => {
    const { enrolled, loading } = this.state

    return <Fragment>
      Enrolled:
      <Switch
        checked={enrolled}
        onChange={this.handleEnrolledChange}
        value="checkedA"
        inputProps={{ 'aria-label': 'secondary checkbox' }}
        disabled={loading}
      />
    </Fragment>
  }

  render = () => {
    return <GenericEnroll
      authMethodName="Out-of-Band Biometric"
      enrolled={this.props.authmethods.oobBio.enrolled}
      renderForm={this.renderForm}
      expanded={this.props.expanded}
      setExpanded={this.props.setExpanded}
      error=""
      dirty={false} />
  }
}

const mapStateToProps = ({ accounts, authmethods, intl }: IStoreState) => ({
  accounts,
  authmethods,
  intl
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      getEnrolledOobBio,
      updateOobBio
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
  expandNext: () => void
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OobBioEnroll))